import Link from "next/link";
import {memo} from "react";
import type {Chat} from "@/lib/db/schema";
import {
  SidebarMenuButton,
  SidebarMenuItem,
} from "./ui/sidebar";
import {LoaderIcon} from "./icons";

const PureChatItem = ({
                        chat,
                        isActive,
                        isStreaming = false,
                        onDelete,
                        setOpenMobile,
                      }: {
  chat: Chat;
  isActive: boolean;
  isStreaming?: boolean;
  onDelete?: (chatId: string) => void;
  setOpenMobile: (open: boolean) => void;
}) => {
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild isActive={isActive} className={isActive ? "bg-primary/10 dark:bg-primary/20 border-l-4 border-primary dark:border-brand-primary-light font-semibold rounded-none" : ""}>
        <Link href={`/chat/${chat.id}`} onClick={() => setOpenMobile(false)}>
          {isStreaming && (
            <div className="animate-spin">
              <LoaderIcon size={14} />
            </div>
          )}
          <span className="truncate">{chat.title}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};

export const ChatItem = memo(PureChatItem, (prevProps, nextProps) => {
  if (prevProps.isActive !== nextProps.isActive) {
    return false;
  }
  if (prevProps.isStreaming !== nextProps.isStreaming) {
    return false;
  }
  return true;
});
